/**
 * Owner: Haselton Baker Risk Group, LLC
 * Date: 2022-02-04
 * Copyright All Rights Reserved
 */
import ComponentQuestion from './ComponentQuestion.jsx';

export default ComponentQuestion;
